'use strict';

function AddSTController($scope, $mdDialog, statesTemplates) {
  'ngInject';

  $scope.statesTemplates = statesTemplates;

  $scope.selectedST = function(st) {
    $mdDialog.hide(st);
  };

  $scope.querySearch = function(text) {
    const matches = this.statesTemplates.filter(
      pt => pt.name.toLowerCase().indexOf(text.toLowerCase()) > -1
    );
    return matches;
  };

  $scope.cancel = function() {
    $mdDialog.cancel();
  };
}

export default AddSTController;
